import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';
import * as _ from 'lodash';
import { NgFor, NgIf } from '@angular/common';

interface Logic {
  logicalOptr: string;
  isValid: boolean;
  target: string;
  interaction: string;
  comparisonOptr: string;
  value: any;
  targetInteraction?: string;
  isOpen?: boolean;
  isEditMode?: boolean;
  configuration?: any
}

interface Option {
  text: string;
  field_id: string;
  labelId: string;
  conditionalLabel: {
    [key: string]: {
      text: string;
      field_id: string;
      customExpression?: string;
      logicDetail?: Logic[];
    }[];
  };
}

interface Question {
  text: string;
  field_id: string;
  group_id?: string;
  group_text?: string;
  options?: Question[];
  interaction_type?: string;
  allowMultiSelect?: boolean;
  readOnly?: boolean;
  prop?: any[];
  is_primary_rating?: boolean;
  is_primary_comment?: boolean;
}

interface QuestionGroup {
  text: string;
  field_id: string;
  options: Question[];
}

@Component({
  selector: 'app-interaction-conditional-labels',
  templateUrl: './interaction-conditional-labels.component.html',
  styleUrls: ['./interaction-conditional-labels.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, FormsModule]
})
export class InteractionConditionalLabelsComponent implements OnInit {
  @Input() interaction: any;
  @Input() readOnly: boolean = false;
  @Output() onChange: any = new EventEmitter<any>()

  selectedActionType: 'display' | 'custom' = 'display';
  logicalOperators = [
    { value: '&&', text: 'AND' },
    { value: '||', text: 'OR' }
  ];
  comparisonOperators = [
    { value: '>=', text: 'Greater than Equals' },
    { value: '<=', text: 'Less than Equals' },
    { value: '>', text: 'Greater than' },
    { value: '<', text: 'Less than' },
    { value: '!=', text: 'Not Equals' },
    { value: '==', text: 'Equals' }
  ];

  isDisplayCondtionActive: boolean = true;
  isCustomCondtionActive: boolean = false
  /**
   * @name operators
   * @description  for storing  operators 
   * @type {Object}  logical{Object} , comparison{Object}
   * @note please make sure comparison object must be descending sorted order as comparison.text length.  
   **/
  operators: any = {
    logical: [{
      op: "||",
      text: "OR"
    }, {
      op: "&&",
      text: "AND"
    }],
    comparison: [{
      op: ">=",
      text: "Greater than Equals"
    }, {
      op: "<=",
      text: "Less than Equals"
    }, {
      op: ">",
      text: "Greater than"
    }, {
      op: "<",
      text: "Less than"
    }, {
      op: "!=",
      text: "Not Equals"
    }, {
      op: "==",
      text: "Equals"
    }]
  };

  /* default condtion actions */
  actions: any = {
    '1': {
      value: "1",
      text: "Show",
      actionProperty: 'visible-if'
    },
    '2': {
      value: "2",
      text: "Mandatory",
      actionProperty: 'is_mandatory_if',
    },
    '3': {
      value: "3",
      text: "Server Visible",
      actionProperty: 'server-visible-if',
    }
  };

  componentConditions: any = {
    logicDetail: {
      "1": {
        "logicString": null,
        "logicKey": "1",
        "editMode": false,
        "transformString": [],
        "transformOrignal": []
      },
      "2": {
        "logicString": null,
        "logicKey": "2",
        "editMode": false,
        "transformString": [],
        "transformOrignal": []
      },
      "3": {
        "logicString": null,
        "logicKey": "3",
        "editMode": false,
        "transformString": null,
        "transformOrignal": null
      }
    },
    logicAction: "1"
  };
  logicDetailsMap: any = {}

  questions: Question[] = []
  currentQuestion: any = null
  /* conditions instance */
  questionConditions: any = null;
  /* question fields instance */
  questionFields: any = null;
  /* question id field */
  questionFieldId: string = 'not set';

  // show hide variables
  isLogicAvailable: boolean = false;
  isShowLogicAvailable: boolean = false;
  isServerLogicAvailable: boolean = false;
  isMandatoryLogicAvailable: boolean = false;
  showDisplay: boolean = true;
  optionIndex: number = -1;

  isClickedAddCondition: boolean = false;

  subQuestionFieldId: any;
  subQuestionIndex: number = -1;
  selectedAction: any = null;
  conditionForOptionLabelSelected: any = null;
  currentOptionFieldId: any = null;

  logicAction: string = '1';
  constructor(private fb: FormBuilder, private _conversations: ConversationService) { }
  loading: boolean = true
  ngOnInit(): void {
    this.resetComponent();
    this.loading = true;
    this.initializeQustions().then(() => {
      if (!_.isEmpty(this.interaction)) {
        let promises: any[] = [];
        _.each(this.interaction.sub_questions, (option: any) => {
          this.questionMapForOptions[option.field_id] = []
          this.questionMapForOptions[option.field_id] = this.getFilteredQuestions(option, null, this.logicAction)
          console.log("questionMapForOptions",this.questionMapForOptions)
          if (option.conditionalLabel && option.labelId) {
            _.each(option.conditionalLabel[option.labelId], (cLabel: any, cLabelIndex: number) => {
              promises.push(this.initialize(option.field_id, cLabel.field_id, cLabelIndex))
            })
          }
        })
        Promise.all(promises).then(() => {
          this.loading = false;
        });
      }
    });


  }

  resetComponent() {
    this.questionMapForOptions = {};
    this.logicDetailsMap = {};
    this.questionConditions = {};
    this.currentQuestion = null;
    this.questionFields = {};
    this.questions = [];
    this.questionFieldId = 'not set';
  }


  /**
    * Initialization
    */
  initialize(fieldId, cLabelFieldId, cLabelIndex, optionDetails?: any) {
    return new Promise((resolve, reject) => {
      if (fieldId) {
        this.currentOptionFieldId = fieldId;
        this.subQuestionFieldId = cLabelFieldId;
        if (!this.logicDetailsMap[cLabelFieldId]) {
          this.logicDetailsMap[cLabelFieldId] = Helpers.deepClone(this.componentConditions)
        }
        this.findIndexForSubQuestion(fieldId, cLabelFieldId);
        if (optionDetails && optionDetails.logicDetail) {
          this.logicDetailsMap[cLabelFieldId].logicDetail = optionDetails.logicDetail
        }
      }
      this.editOptionCondition(cLabelFieldId, cLabelIndex, fieldId);
      setTimeout(() => {
        Promise.all([
          this.newExpression('1', cLabelFieldId, cLabelIndex, fieldId),
          this.newExpression('2', cLabelFieldId, cLabelIndex, fieldId),
          this.newExpression('3', cLabelFieldId, cLabelIndex, fieldId)
        ]).then(() => {
          resolve(true);
        });
      }, 400);

    })


  }

  findIndexForSubQuestion(fieldId, clabelId) {
    if (!_.isEmpty(this.interaction)) {
      var index = _.findIndex(this.interaction.sub_questions, {
        'field_id': fieldId
      });
      if (clabelId >= 0 && index >= 0) {
        this.optionIndex = index;
        this.subQuestionIndex = clabelId;
      }
    }
  }
  isEditMode: boolean = false
  editOptionCondition(cLabelFieldId: any, cLabelIndex: any, optionFieldId: any, logicAction?: any) {
    // this.questionFieldId = optionFieldId;
    if (logicAction) {
      this.isEditMode = true;
    }
    this.setCurrentQuestion(cLabelIndex, optionFieldId);
    this.setQuestions(cLabelIndex, optionFieldId);
    this.setQuestionConditionsForSubQuestion(optionFieldId, cLabelFieldId, cLabelIndex);
    // resetComponentConditions();
    this.copyQuestionConditions(cLabelFieldId);

    this.logicAction = logicAction ? logicAction : '1';
    this.editConditionInnerFunction(cLabelFieldId, optionFieldId, true);
  }

  setQuestionConditionsForSubQuestion(optionFieldId: any, cLabelFieldId: any, cLabelIndex: any) {
    this.questionConditions = {};
    const option = this.interaction?.sub_questions?.find((q: Option) => q.field_id === optionFieldId);

    if (!this.questionConditions[cLabelFieldId]) {
      this.questionConditions[cLabelFieldId] = {};
    }
    _.each(this.actions, (action) => {
      if (_.get(option, 'conditionalLabel')) {
        const currentQuestion = _.get(option, 'conditionalLabel[' + option.labelId + '][' + cLabelIndex + ']');
        if (!_.isEmpty(currentQuestion) && currentQuestion[action.actionProperty]) {
          this.questionConditions[cLabelFieldId][action.actionProperty] = currentQuestion[action.actionProperty];
        } else {
          this.questionConditions[cLabelFieldId][action.actionProperty] = '';
        }
      }
    });
  }

  /**
   * @name copyQuestionConditions
   * @description copying conditions to local instance from parent instance in this case conversation designer 
   */
  copyQuestionConditions(cLabelFieldId) {
    _.each(this.logicDetailsMap[cLabelFieldId].logicDetail, (action) => {
      if (_.get(this.questionConditions, cLabelFieldId + '.' + this.actions[action.logicKey].actionProperty)) {
        action.logicString = this.questionConditions[cLabelFieldId][this.actions[action.logicKey].actionProperty];
      }
    });
  }

  editConditionInnerFunction(cLabelFieldId: string, optionFieldId: string, isCheckChildExpression) {
    var currentParentQuestion = this.interaction?.sub_questions?.find((q: Option) => q.field_id === optionFieldId); //this.interaction.sub_questions[this.optionIndex];
    // looop through each actions {Show, Mandatory, Server Visible}
    _.each(this.logicDetailsMap[cLabelFieldId].logicDetail, (logic: any, index: any) => {
      //true for show and mandatory actions and is edit mode true
      //if we have server visible i.e logicKey is 3 then provide logic string as it is 
      if (logic.logicKey != 3) {
        if (_.get(logic, 'transformString') && _.get(logic, 'logicString') && (logic.transformString.length == 0) && (typeof logic.logicString == 'string')) {
          var expressions = logic.logicString;
          if (isCheckChildExpression) {
            var checkChildBracket = expressions.indexOf('((');
            if (checkChildBracket !== 1) {
              /**
               * Removing brackets for getting the proper expression
               * for displaying data in the modal popup
               */
              expressions = expressions.replace(/\(\(/g, "");
              expressions = expressions.replace(/\)\)/g, "");
            }

            // expressions = expressions.replace(/ *\([^)]*\) */g, "");
            var lastBracketIndex = expressions.lastIndexOf('(');
            if (lastBracketIndex !== -1) {
              expressions = expressions.substring(0, lastBracketIndex);
              if (expressions && expressions.length > 2) {
                var isOperator = expressions.slice(-2);
                if (isOperator === '&&') {
                  expressions = expressions.substring(0, expressions.length - 2);
                }
              }
            }
          }

          // split string on OR | AND as a seperator
          expressions = expressions.split(/\&\&|\|\|/);
          if (expressions.length) {
            //remove logic expresstion from string for getting AND & OR operator array
            var conditions = _.compact(logic.logicString.match(/(&&)?(\|\|)*/g));
            //loop through expressions getting from logic string
            _.each(expressions, (expression, index) => {
              //assign logical operator if not a first operator
              var logicalOperator = index > 0 ? conditions[index - 1] : '||';
              //create object from sring
              var stringObject = this.createObjectFromExpression(expression, logicalOperator);

              stringObject.logicString = this.getFormatedLogicString(stringObject);
              if (stringObject.configuration && stringObject.value) {
                const config = _.find(stringObject.configuration, function (config) {
                  return stringObject.value == config.value;
                });
                stringObject.value = config?.value || '';
              }
              stringObject.isOpen = false;
              var isValidity = this.formValidity(stringObject);
              stringObject.isValid = (isValidity) ? true : false;
              //push above created query string object in transform string array of respective action 
              if (stringObject.isValid) {
                logic.transformString.push(stringObject);
              }
              //if edit mode is true then set it to false
              else if (!logic.editMode) {
                //copying string transform object to array variable
                logic.transformOrignal.push(_.cloneDeep(stringObject));
              } else {
                //push above created query string object in transform string array of respective action 
                logic.transformString.push(stringObject);
              }
            });
          } else {
            logic.transformString = [this.getQueryStringObject({})];
          }

          //set sub action editmode to true
          logic.editMode = true;
        }
      } else {
        var expressions = logic.logicString;
        if (isCheckChildExpression && expressions) {
          var parentQueExpressions = currentParentQuestion['server-visible-if'];
          if (parentQueExpressions) {
            parentQueExpressions = '(' + parentQueExpressions + ')';
            var indexOfParentExp = expressions.indexOf(parentQueExpressions);
            if (indexOfParentExp !== -1) {
              expressions = expressions.substring(0, indexOfParentExp);
              if (expressions && expressions.length > 2) {
                var isOperator = expressions.slice(-2);
                if (isOperator === '&&') {
                  expressions = expressions.substring(0, expressions.length - 2);
                }
              }
              this.logicDetailsMap[cLabelFieldId].logicDetail[index].logicString = expressions;
            }
          }
        }
      }
    });
    this.isLogicAvailable = true;
  };

  formValidity = function (logic) {
    logic.target = logic.target || 'target_value';
    if (logic.interaction && logic.comparisonOptr && logic.target) {
      if (logic.target == 'target_value' || logic.target == 'target_field') {
        if (logic.value || logic.targetInteraction) {
          return true;
        }
      }
    }
    return false;
  };


  /**
   * @name  createObjectFromExpression
   * @description create getQueryStringObject object for action's logic transform string from string expression, asssigning logical operator 
   * @param {string} expression - expression string 
   * @param {string} logicalOperator - logical operator for e.g. ['&&'|'||'] 
   */
  createObjectFromExpression(expression, logicalOperator) {
    //initialize query string object with target and logical operator property
    var queryStringObject = this.getQueryStringObject({});
    //compaire operator.comparison with the string for picking up expression operator
    _.each(this.operators.comparison, (comparisonOptr: any, index: any) => {
      //true if operator found in a string
      if (expression.lastIndexOf(comparisonOptr.op) > -1) {
        //assigning question in the object 
        queryStringObject.interaction = expression.substr(0, expression.lastIndexOf(comparisonOptr.op) - 1);
        //getting question parameter of selected question and assign it to configuration
        queryStringObject.configuration = this.getQuestionParameters(queryStringObject.interaction);
        //split expresson on the basis of coparison operator
        var literals = expression.split(comparisonOptr.op);
        //assigning question in the object
        switch (literals[0]) {
          case 'rating.primary_rating':
            queryStringObject.interaction = 'primary_rating';
            break;
          case 'rating.comments':
            queryStringObject.interaction = 'comments';
            break;
          default:
            queryStringObject.interaction = literals[0].substr(24).slice(0, -2);
        }

        //getting question parameter of selected question and assign it to configuration
        queryStringObject.configuration = this.getQuestionParameters(queryStringObject.interaction);
        var targetString = literals[1];
        queryStringObject.target = 'target_field';

        //assigning target question/value in the object
        switch (literals[1]) {
          case 'rating.primary_rating':
            queryStringObject.targetInteraction = 'primary_rating';
            break;
          case 'rating.comments':
            queryStringObject.targetInteraction = 'comments';
            break;
          default:
            if (this.isInteraction(targetString)) {
              //assign to query string object
              //removing "rating.detailed_rating['']" from logic string 
              queryStringObject.targetInteraction = literals[1].substr(24).slice(0, -2);
            } else {
              queryStringObject.target = 'target_value';
              //remove blank spaces from string splited above and assign to query string object
              queryStringObject.value = targetString;
            }
        }
        //assign comparison operator
        queryStringObject.comparisonOptr = comparisonOptr.op;
        queryStringObject.logicalOptr = logicalOperator;
        //returning from loop
        return false;
      }
      return true;

    });
    return queryStringObject;
  };

  /*
    * @name  getQuestionParameters
    * @description set question parameter for question/interaction options as configuration object
    * @param {string} fieldId - field id
    * @returns {[Object]|null} - configuration parameter or null
    */
  getQuestionParameters(fieldId: string) {
    var question = this.getQuestionByFieldId(fieldId);
    if (question && _.get(question, 'prop')) {
      return _.map(question.prop, (prop: any) => { return prop; });
    } else {
      return null;
    }
  };


  /**
   * @name isInteraction
   * @description check whether given string is question/interaction or not
   * @param {string} fieldId - field id
   * @return {boolean} - true is value is question/interaction else false
   */
  isInteraction(fieldId: string) {
    var question = undefined;
    var result = fieldId.match("rating.detailed_rating(.*)");
    if (result && result[1] && result[1].indexOf('[') !== -1 && result[1].indexOf(']') !== -1) {
      fieldId = result[1].replace(/[\[\]']/g, '');
    }
    if (_.get(this._conversations, 'configuration.fields')) {
      question = _.find(this._conversations.configuration.fields, { 'field_id': fieldId });
    }
    return (typeof question === 'object');
  };



  getFormatedLogicString(queryObject) {
    var logicStr = '';
    var targetInteractionQuestion = '';
    var interactionId = [];

    if (queryObject.value && isNaN(queryObject.value) && queryObject.value.indexOf("rating.") > -1) {
      if (queryObject.value.indexOf("primary_rating") > -1) {
        queryObject.targetInteraction = 'primary_rating';
      } else {
        interactionId = queryObject.value.split("['");
        if (interactionId[interactionId.length - 1]) {
          let text: any = interactionId[interactionId.length - 1]
          queryObject.targetInteraction = text.replace("']", '');
        }
      }

      queryObject.target = 'target_field';
    }

    _.each(this.questions, function (questions) {
      if (queryObject.interaction && questions.field_id) {
        if (questions.field_id == queryObject.targetInteraction && queryObject.target == 'target_field') {
          targetInteractionQuestion = questions.text;
        }

        if (questions.field_id === queryObject.interaction) {
          logicStr = logicStr + (questions.text || '') + '  ' + (queryObject.comparisonOptr || '') + '  ';
        }
      }
    });


    if (queryObject.configuration && (!queryObject.targetInteraction || !(queryObject.target == 'target_field'))) {
      for (var j = 0; j < queryObject.configuration.length; j++) {
        if (queryObject.configuration[j].value && queryObject.value) {
          if (queryObject.configuration[j].value == queryObject.value) {
            logicStr = logicStr + '"' + (queryObject.configuration[j].label || '') + '"';
            break;
          }
        }
      }
    } else {
      logicStr = logicStr + ' "' + targetInteractionQuestion + '"';
    }

    return logicStr;
  }

  onActionTypeChange(type: 'display' | 'custom'): void {
    this.selectedActionType = type;
    this.logicAction = (type == 'custom') ? '3' : '1'
  }

  getLogicDetails(fieldId: string, labelId: string): Logic[] {
    const option = this.interaction?.sub_questions?.find((q: Option) => q.field_id === fieldId);
    if (!option) return [];

    const label = option.conditionalLabel[option.labelId]?.find(l => l.field_id === labelId);
    if (!label) return [];

    if (!label.logicDetail) {
      label.logicDetail = {};
    }
    // if
    // this.logicDetailsMap[labelId]
    return label.logicDetail;
  }

  getQuestionText(fieldId: string | undefined): string {
    if (!fieldId) return '';
    const question = this.questions?.find((q: any) => q.field_id === fieldId);
    return question?.text || '';
  }

  getOperatorText(operator: string): string {
    const op = this.comparisonOperators.find(o => o.value === operator);
    return op ? op.text : operator;
  }

  getFilteredQuestions(currentQuestion: any, targetField: any, action?: any): (Question | QuestionGroup)[] {
    let questions = _.filter(_.cloneDeep(this.questions), (question: Question) => {
      if ((currentQuestion && currentQuestion.field_id && question.field_id && (currentQuestion.field_id == question.field_id)) || (question.group_id && (question.group_id == currentQuestion.field_id))) {
        if (action == '2' && (question.group_id == currentQuestion.field_id)) {
          return true;
        } else {
          return false;
        }
      }
      if (targetField && targetField == _.get(question, 'field_id')) {
        return false;
      }
      return true;
    })
    let groups: { [key: string]: Question | QuestionGroup } = {}
    _.each(questions, (question: Question) => {
      if (question.group_text) {
        if (!groups[question.group_id!]) {
          groups[question.group_id!] = {
            text: question.group_text,
            field_id: question.group_id!,
            options: []
          } as QuestionGroup
        }
        if(groups[question.group_id!] && !groups[question.group_id!]?.options ){
          groups[question.group_id!].options = [];
        }
        (groups[question.group_id!] as QuestionGroup).field_id = question.group_id!;
        (groups[question.group_id!] as QuestionGroup).text = question.group_text;
        (groups[question.group_id!] as QuestionGroup).options.push(question)
      } else {
        groups[question.field_id] = question
      }
    });
    return Object.values(groups)
  }

  isQuestionGroup(obj: Question | QuestionGroup): obj is QuestionGroup {
    return 'options' in obj && Array.isArray(obj.options);
  }

  isQuestion(obj: Question | QuestionGroup): obj is Question {
    return !('options' in obj) || !Array.isArray(obj.options);
  }

  selectedQUestion: string = ''
  getConfiguration(logic: Logic): any[] {
    if (!logic.interaction) return [];
    // const question = logic.find((q: Option) => q.field_id === logic.interaction);
    // if (!question) return [];

    // Return configuration based on question type
    return (logic?.configuration && logic?.configuration?.length) ? logic?.configuration : [];
  }

  emitChange: boolean = false;
  addCondition(logic: Logic, fieldId: string, cLabelFieldId, cLabelIndex: any): void {
   
    if (this.validateCondition(logic)) {
      this.emitChange = true;
      logic.isValid = true;
      logic.isOpen = false;
      this.findIndexForSubQuestion(fieldId, cLabelIndex)
      // Remove the old system calls since we're using a different approach
      if (logic.isOpen === false && !logic.isEditMode) {
        this.newExpression(this.logicAction, cLabelFieldId, cLabelIndex, fieldId);
      }
      this.updateCurrentCondition(cLabelFieldId, this.logicAction);
    }
  }

  newExpression(logicAction, cLabelFieldId, cLabelIndex, fieldId) {
    return new Promise((resolve, reject) => {
      let componentConditions = this.logicDetailsMap[cLabelFieldId];
      if (componentConditions?.logicDetail && componentConditions?.logicDetail[logicAction] && componentConditions.logicDetail[logicAction]?.transformString) {
        _.each(componentConditions.logicDetail[logicAction].transformString, function (expression) {
          if (expression.isOpen) {
            expression.isOpen = false;
          }
        });
      }
      let transformString = _.get(componentConditions, 'logicDetail.' + logicAction + '.transformString', [])
      if (_.isEmpty(transformString) && _.isArray(transformString)) {
        componentConditions.logicDetail[logicAction].transformString.push(this.getQueryStringObject({}));
      }
      this.logicDetailsMap[cLabelFieldId] = Helpers.deepClone(componentConditions)
      this.setQuestions(cLabelIndex, fieldId);
      resolve(true);
    })
  };




  /**
   * @description to set transition object after selecting/changing interaction
   * @param {integer} arrayIndex - index of an array
   * @param {Object} queryStringObject - queryStringObject
   * @param {string} logicAction - logic action 
   */
  updateTransitionObject(labelId: string, queryStringObject: any, logicAction: any) {
    var questionFields: any = null;
    if (queryStringObject.hasOwnProperty('interaction')) {
      questionFields = this.getQuestionByFieldId(queryStringObject.interaction);
      if (_.get(questionFields, 'prop')) {
        queryStringObject.configuration = _.map(questionFields.prop, (prop: any) => { return prop; });
      }
    }
    if (_.get(this.logicDetailsMap[labelId], 'logicDetail.' + logicAction + '.transformString')) {
      var transitionObject: any = null;
      _.each(this.logicDetailsMap[labelId].logicDetail[logicAction].transformOrignal, (logic: any) => {
        if (logic.interaction == queryStringObject.interaction) {
          transitionObject = _.cloneDeep(logic);
          return;
        }
      });
      if (!transitionObject) {
        if (questionFields && questionFields.hasOwnProperty('group_id') && questionFields.hasOwnProperty('group_text') && (_.get(questionFields, 'interaction_type') == 'multi-select')) {
          var value = null;
          if (queryStringObject.configuration && queryStringObject.configuration.length > 0) {
            value = queryStringObject.configuration[0].value.toString();
          }
          transitionObject = this.getQueryStringObject({
            interaction: queryStringObject.interaction,
            comparisonOptr: '==',
            target: 'target_value',
            value: value,
            logicalOptr: queryStringObject.logicalOptr
          });
        } else {
          var target = '';
          if (queryStringObject.configuration && queryStringObject.configuration.length > 0) {
            target = 'target_value';
          }
          transitionObject = this.getQueryStringObject({
            interaction: queryStringObject.interaction,
            configuration: queryStringObject.configuration,
            logicalOptr: queryStringObject.logicalOptr,
            target: target
          });
        }
      }

      if (this.logicDetailsMap[labelId].logicDetail[logicAction].transformString.length > 0) {
        // this.logicDetailsMap[fieldId].logicDetail[logicAction].transformString[arrayIndex] = transitionObject;
      } else {
        this.logicDetailsMap[labelId].logicDetail[logicAction].transformString.push(transitionObject);
      }
    }
  };

  /**
   * @name setQuestions
   * @description  set questions object array from conversation designer parent
   **/
  setQuestions(cLabelIndex, fieldId) {
    this.setCurrentQuestion(cLabelIndex, fieldId);
    const option = _.find(this.questions, (q) => { return q.field_id == fieldId })
    this.questionMapForOptions[fieldId] = this.getFilteredQuestions(option, null, this.logicAction)
    // this.initializeQustions()
  }

  initializeQustions() {
    return new Promise((resolve, reject) => {
      this.questions = [];
      if (_.get(this._conversations, 'configuration.fields')) {
        var fields = _.cloneDeep(this._conversations.configuration.fields);
        _.each(fields, (field) => {
          var interactionType = _.get(field, 'interaction_type');
          if (interactionType != 'label' && interactionType != 'image' && !field.hasOwnProperty('readOnly')) {
            if (field.hasOwnProperty('group_id') && field.hasOwnProperty('group_text') && (field.interaction_type == 'multi-select')) {
              this.questions.push(field);
            } else if (!field.hasOwnProperty('group_id') && !field.hasOwnProperty('group_text') && !_.get(field, 'allowMultiSelect')) {
              this.questions.push(field);
            }
          }
        });
      }
      resolve(true);
    })


  }

  compareObjects(object1: any, object2: any): boolean {
    return object1 && object2 && object1.id === object2.id; // Example comparison
  }
  /**
   * @name  setCurrentQuestion
   * @description  set current question object from conversation designer parent
   * 
   **/
  setCurrentQuestion(cLabelIndex, optionFieldId) {
    this.currentQuestion = null;
    if (_.get(this, 'interaction')) {
      var _subQuestion = _.find(this.interaction.sub_questions, { "field_id": optionFieldId });
      this.currentQuestion = _subQuestion.conditionalLabel[_subQuestion.labelId][cLabelIndex];
    }


  }

  /*
   * @name getQueryStringObject
   * @typedef {Object} getQueryStringObject
   * @property {Object.string} interaction - interaction
   * @property {Object.string} comparisonOptr - comparison operator string
   * @property {Object.string} target - target field or target value
   * @property {Object.string} value - value compairing with question input
   * @property {Object.string} logicalOptr - logical operator string
   * @property {Object[Object]} configuration - configuration for the parameter
   * @return {Object} stringObject - query string object 
   **/
  getQueryStringObject(queryStringObject) {
    var stringObject: any = {};
    if (!_.isEmpty(queryStringObject)) {
      stringObject.interaction = _.get(queryStringObject, 'interaction') ? queryStringObject.interaction : '';
      stringObject.comparisonOptr = _.get(queryStringObject, 'comparisonOptr') ? queryStringObject.comparisonOptr : '';
      stringObject.value = _.get(queryStringObject, 'value') ? queryStringObject.value : '';
      stringObject.targetInteraction = _.get(queryStringObject, 'targetInteraction') ? queryStringObject.targetInteraction : '';
      stringObject.logicalOptr = _.get(queryStringObject, 'logicalOptr') ? queryStringObject.logicalOptr : '||';
      stringObject.target = _.get(queryStringObject, 'target') ? queryStringObject.target : '';
      stringObject.configuration = _.get(queryStringObject, 'configuration') ? queryStringObject.configuration : [];
      stringObject.isOpen = true;
    } else {
      stringObject = {
        logicalOptr: '||',
        isValid: false,
        target: 'target_value',
        interaction: '',
        comparisonOptr: '',
        value: '',
        isOpen: true,
        configuration: []
      }
    }

    //   logicalOptr: '&&',
    //   isValid: false,
    //   target: 'target_value',
    //   interaction: null,
    //   comparisonOptr: '',
    //   value: '',
    //   isOpen: true,
    //   configuration: []
    return stringObject;
  };


  editCondition(logic: Logic): void {
    logic.isOpen = true;
    logic.isEditMode = true;
  }

  openEditContainer(logicObj, index, valueConfig) {
    this.toggleForAddCondition();
    setTimeout(() => {
      if (logicObj && !logicObj.isOpen) {
        logicObj.isOpen = true;
        logicObj.isEditMode = true;
      } else if (logicObj && logicObj.isOpen) {
        logicObj.isOpen = false;
        logicObj.isEditMode = false;
      }
    }, 100);
  }


  toggleForAddCondition(cLabelIndex?: any, field_id?: any) {
    if (_.get(this, 'conditionForOptionLabelSelected')) {
      this.selectedAction = this.conditionForOptionLabelSelected;
      if (this.selectedAction === 'display') {
        this.isDisplayCondtionActive = true;
        this.isCustomCondtionActive = false;
      } else if (this.selectedAction === 'custom') {
        this.isCustomCondtionActive = true;
        this.isDisplayCondtionActive = false;
      }
      if (this.isClickedAddCondition) {
        this.isClickedAddCondition = false;
      }
    }
  }



  closeCondition(cLabelFieldId: string, index: any) {
    var transformArray = this.logicDetailsMap[cLabelFieldId].logicDetail[this.logicAction].transformString;
    if (this.logicDetailsMap[cLabelFieldId].logicDetail[1].transformString[index].interaction == null) {
      this.isClickedAddCondition = true;
    } else {
      if (transformArray.length === 1) {
        transformArray[0] = { "interaction": '', "comparisonOptr": '', "value": '', "targetInteraction": '', "logicalOptr": "||", "target": "", "configuration": [], "isOpen": true };
        this.isClickedAddCondition = false;
      } else {
        if ((transformArray.length - 1) !== index) {
          transformArray.splice(index, 1);
        } else {
          transformArray[index] = { "interaction": '', "comparisonOptr": '', "value": '', "targetInteraction": '', "logicalOptr": "||", "target": "", "configuration": [], "isOpen": true };
        }
      }
    }
    this.updateCurrentCondition(cLabelFieldId, this.logicAction);
  };



  removeCondition(logic: Logic): void {
    const option = this.interaction?.sub_questions?.find((q: Option) => q.field_id === logic.interaction);
    if (!option) return;

    const label = option.conditionalLabel[option.labelId]?.find(l => l.field_id === logic.targetInteraction);
    if (!label || !label.logicDetail) return;

    const index = label.logicDetail.indexOf(logic);
    if (index > -1) {
      label.logicDetail.splice(index, 1);
    }
  }

  // closeCondition(logic: Logic): void {
  //   logic.isOpen = false;
  //   logic.isEditMode = false;
  // }

  questionMapForOptions: any = {}
  toggleAddCondition(label: any, fieldId: string): void {
    const option = this.interaction?.sub_questions?.find((q: Option) => q.field_id === fieldId);
    if (!option) return;

    const labelObj = option.conditionalLabel[option.labelId]?.find(l => l.field_id === label.field_id);
    if (!labelObj) return;

    if (!labelObj.logicDetail) {
      labelObj.logicDetail = {};
    }

    this.questionMapForOptions[fieldId] = this.getFilteredQuestions(option, null, this.logicAction)
    this.logicDetailsMap[label.field_id].logicDetail[this.logicAction].transformString.push({
      logicalOptr: '&&',
      isValid: false,
      target: '',
      interaction: '',
      comparisonOptr: '',
      value: '',
      isOpen: true,
      configuration: []
    })
  }

  updateLogicalOperator(logic: Logic, value: string): void {
    logic.logicalOptr = value;
  }

  onQuestionChange(labelId: string, logic: Logic): void {
    logic.comparisonOptr = '';
    logic.value = '';
    logic.targetInteraction = '';

    // Update configuration when interaction changes
    if (logic.interaction) {
      const question = this.getQuestionByFieldId(logic.interaction);
      if (question && question.prop) {
        logic.configuration = _.map(question.prop, (prop: any) => prop);
      } else {
        logic.configuration = [];
      }
    } else {
      logic.configuration = [];
    }
    this.updateTransitionObject(labelId, logic, this.logicAction)
  }

  onValueChange(logic: Logic): void {
    // Remove the updateCurrentCondition call since we're using a different approach
    // this.updateCurrentCondition(logic);
  }

  getCustomExpression(fieldId: string, labelId: string): string {
    const option = this.interaction?.sub_questions?.find((q: Option) => q.field_id === fieldId);
    if (!option) return '';

    const label = option.conditionalLabel[option.labelId]?.find(l => l.field_id === labelId);
    return label?.customExpression || '';
  }

  updateCustomExpression(fieldId: string, cLabelFieldId: string, cLabelIndex: any, logicAction: string): void {
    this.findIndexForSubQuestion(fieldId, cLabelIndex)
    this.updateCurrentCondition(cLabelFieldId, logicAction)

  }

  addNewConditionalLabel(option: Option): void {
    if (!option.conditionalLabel) {
      option.conditionalLabel = {};
    }
    if (!option.conditionalLabel[option.labelId]) {
      option.conditionalLabel[option.labelId] = [];
    }

    let newLabelObject: any = {
      text: '',
      field_id: this.generateId('question'),
      customExpression: '',
      logicDetail: {}
    }
    option.conditionalLabel[option.labelId].push(newLabelObject);
    this.logicDetailsMap[newLabelObject.field_id] = Helpers.deepClone(this.componentConditions);
  }

  removeConditionalLabel(label: any, option: Option): void {
    const index = option.conditionalLabel[option.labelId].indexOf(label);
    if (index > -1) {
      option.conditionalLabel[option.labelId].splice(index, 1);
    }
  }

  private validateCondition(logic: Logic): boolean {
    if (!logic.interaction || !logic.comparisonOptr || !logic.target) {
      return false;
    }
    if (logic.target === 'target_value' && !logic.value) {
      return false;
    }
    if (logic.target === 'target_field' && !logic.targetInteraction) {
      return false;
    }
    return true;
  }

  updateCurrentCondition(cLabelFieldId, logicAction) {
    //data memeber for copying object string to conversation designers -> question -> logic details -> logic string 
    var logicString = '';
    //data memeber for copying object string to conversation designers -> question -> (equivalent action) 
    var logicObjectString = '';
    //if action should not be server visible i.e. 3
    if (logicAction.toString() != '3' && _.get(this.logicDetailsMap[cLabelFieldId], 'logicDetail.' + logicAction + '.transformString')) {
      var firstCondition = true;
      _.each(this.logicDetailsMap[cLabelFieldId].logicDetail[logicAction].transformString, (expression) => {

        if (this.isTransformStringObjectValid(expression)) {
          if (firstCondition) {
            firstCondition = false;
          } else {
            if (_.get(this.operators, 'logical.' + expression.logicalOptr + '.text')) {
              logicObjectString += expression.logicalOptr;
              logicString += this.operators.logical[expression.logicalOptr].text;
            }
          }

          var srcField = this.getQuestionByFieldId(expression.interaction);
          if (_.get(expression, 'comparisonOptr') && srcField) {
            logicObjectString += this.getInteractionFieldString(srcField) + expression.comparisonOptr;
          }

          if (srcField) {
            logicString += '(' + srcField.text + ' ' + this.getOperatorText(expression.comparisonOptr) + ' ';

            if (expression.target == 'target_field') {
              var destField = this.getQuestionByFieldId(expression.targetInteraction)
              if (destField) {
                logicObjectString += this.getInteractionFieldString(destField);
                logicString += destField.text + ')';
              }
            } else {
              if (expression.value !== null && expression.value !== undefined) {
                logicObjectString += expression.value;
                logicString += expression.value + ')';
              } else {
                logicObjectString += expression.value.value;
                logicString += expression.value.value + ')';
              }
            }
          }
        }
      });

    } else {
      if (_.get(this.logicDetailsMap[cLabelFieldId], 'logicDetail.' + logicAction + '.logicString')) {
        logicString = this.logicDetailsMap[cLabelFieldId].logicDetail[logicAction].logicString.trim();
        logicObjectString = this.logicDetailsMap[cLabelFieldId].logicDetail[logicAction].logicString.trim();
      }
    }
    this.addConditionString(logicAction, logicString, logicObjectString);
  };



  /**
   * @name isTransformStringObjectValid
   * @description check whether given transition string object is valid or not
   * @param {Object} expression - string tranformation object
   * @return {boolean} - true if transition string object is valid 
   **/
  isTransformStringObjectValid(expression) {
    if (expression.interaction && expression.comparisonOptr && (expression.target == 'target_field' ? expression.targetInteraction : expression.value)) {
      return true;
    }
    return false;
  };

  /**
   * @name getQuestionByFieldId
   * @description  getting question object from parent in this case conversation designer
   * @param {string} fieldId - field id 
   * @return {Question|null} - Question object from conversation designer 
   **/
  getQuestionByFieldId(fieldId: string): Question | null {
    this.questionFields = null;
    if (_.get(this._conversations, 'configuration.fields')) {
      switch (fieldId) {
        case 'primary_rating':
          this.questionFields = _.find(this._conversations.configuration.fields, { is_primary_rating: true, field_id: fieldId });
          break;
        case 'comments':
          this.questionFields = _.find(this._conversations.configuration.fields, { is_primary_comment: true, field_id: fieldId });
          break;
        default:
          this.questionFields = _.find(this._conversations.configuration.fields, { field_id: fieldId });
      }
    }
    return this.questionFields;
  };


  /**
   * @name  getInteractionFieldString
   * @description get expression question from string
   * @param {Question|null} question - question object having properties
   * @return {string} logicObjectString - logic object string with ID's
   **/
  getInteractionFieldString(question: Question | null): string {
    if (!question) return '';

    if (question.is_primary_rating) {
      return 'rating.primary_rating';
    } else if (question.is_primary_comment) {
      return "rating.comments";
    } else {
      return "rating.detailed_rating['" + question.field_id + "']";
    }
  };




  /**
   * @name  addConditionString
   * @description update or push logic action in connversation designers question
   * @param {string} logicAction - name of logic action
   * @param {string} logicString - logic string for logic action
   * @param {string} logicObjectString - logic object string with ID's
   **/
  addConditionString(logicAction: any, logicString: any, logicObjectString: any): void {
    if (typeof logicString == 'string') {
      if (_.get(this.interaction, 'sub_questions[' + this.optionIndex + '].conditionalLabel')) {
        var sub_questions = this.interaction.sub_questions[this.optionIndex];
        if (_.get(this.actions, logicAction + '.actionProperty') && logicString != '') {
          sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex][this.actions[logicAction].actionProperty] = logicObjectString;
        } else {
          delete sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex][this.actions[logicAction].actionProperty];
        }
        if (logicString != '') {
          if (!sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex].logicDetail) {
            sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex]['logicDetail'] = {}
          }
          sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex].logicDetail[logicAction] = {
            'logicKey': logicAction,
            'logicString': logicString
          };

        } else {
          delete sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex].logicDetail[logicAction];
        }

        this.interaction.sub_questions[this.optionIndex] = sub_questions;
      } else {
        var sub_questions = this.interaction.sub_questions[this.optionIndex];
        if (_.get(this.actions, logicAction + '.actionProperty')) {
          sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex][this.actions[logicAction].actionProperty] = logicObjectString;
        }
        sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex]['logicDetail'] = {}
        sub_questions.conditionalLabel[sub_questions.labelId][this.subQuestionIndex].logicDetail[logicAction] = {
          'logicKey': logicAction,
          'logicString': logicString
        };
        this.interaction.sub_questions[this.optionIndex] = sub_questions;
      }

      if(this.emitChange || logicAction == 3 || logicAction == '3'){
        this.onChange.emit(this.interaction)
        this.emitChange = false;
      }
    }
  };

  private generateId(prefix: string): string {
    return `${prefix}_${Math.random().toString(36).substr(2, 9)}`;
  }
}
